export default "__VITE_ASSET__BRsF3Nvo__"